import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { CourseDetailsComponent } from './course/course.component';
import { EventDetailsComponent } from './event/event.component';

@NgModule({
    declarations: [EventDetailsComponent, CourseDetailsComponent],
    imports: [CommonModule, AcademyPresentationUiModule]
})
export class DetailsModule {}
